module.exports = __webpack_public_path__ + "img/ne.ade9752d.svg";